const tableWrapper = (table) => {
  let timer;
  const wrapper = document.createElement('div');
  wrapper.className = 'c-table-wrapper';
  table.parentNode.appendChild(wrapper);
  wrapper.appendChild(table);
  const handler = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (table.offsetWidth > wrapper.offsetWidth) {
        wrapper.classList.add('is-active');
      } else {
        wrapper.classList.remove('is-active');
      }
    }, 500);
  };
  document.addEventListener('DOMContentLoaded', handler);
  window.addEventListener('resize', handler);
  window.addEventListener('load', handler);
};

export default tableWrapper;
